module.exports = __webpack_public_path__ + "img/light-home.3076851c.svg";